import { MobileAssetInfoHeaderStyled } from "../MobileSliderPages/components/styled/MobileAssetInfoHeaderStyled.js";
import { IconAsset } from "../../../components/icon/Icon.jsx";
import React from "react";
import { createStructuredSelector } from "reselect";
import { makeSelectorGetLiteTradeAssetInfo } from "../../../modules/LiteTrade/liteTradeSelectors.js";
import { connect } from "react-redux";

function MobileAssetInfoHeader(props) {
    const {
        assetInfo,
    } = props;

    if (!assetInfo) {
        return null;
    }

    return <MobileAssetInfoHeaderStyled>
        <div className={'col-left'}><IconAsset symbol={assetInfo.symbol}/></div>
        <div className={'col-center'}>
            <div className={'f16 fw600'}>{assetInfo.info.description}</div>
            <div>{assetInfo.symbol}</div>
        </div>
    </MobileAssetInfoHeaderStyled>
}

const mapStateToProps = createStructuredSelector({
    assetInfo: (state, ownProps) => makeSelectorGetLiteTradeAssetInfo(ownProps.symbol)(state, ownProps)
});

const mapDispatchToProps = (dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(MobileAssetInfoHeader);
